  /**
   * The order of these matter. Club types that have matchers that are similar
   * should have the more complex matcher near the top.
   *
   * e.g. 'fountain refill' and 'fountain' matchers will collide,
   * put 'fountain refill' above 'fountain' so the mapping in ./utils.js will work correctly.
   */
export const cardTypes = [ {
  type: 'wash-club',
  name: 'Bronze Car Wash',
  matcher: 'bronze car wash'
}, {
  type: 'wash-club',
  name: 'Silver Car Wash',
  matcher: 'silver car wash'
}, {
  type: 'wash-club',
  name: 'Gold Car Wash',
  matcher: 'gold car wash'
}, {
  type: 'wash-club',
  name: 'Platinum Car Wash',
  matcher: 'platinum car wash'
}, {
  type: 'wash-club',
  name: 'Car Wash Club',
  matcher: 'wash'
}, {
  type: 'hot-bev-club-refill',
  name: 'Hot Beverage Club',
  matcher: 'hot bev refill'
}, {
  type: 'energy-drink-club',
  name: 'Bang Energy Club',
  matcher: 'bang energy',
}, {
  type: 'coffee-club',
  name: 'Coffee Club',
  matcher: 'coffee'
}, {
  type: 'fountain-club-refill',
  name: 'Fountain Refill Club',
  matcher: 'fountain refill'
}, {
  type: 'fountain-club',
  name: 'Fountain Club',
  matcher: 'fountain'
}, {
  type: 'slushie-club',
  name: 'Frozen Drink Club',
  matcher: 'frozen'
}, {
  type: 'freals-club',
  name: "F'reals Club",
  matcher: 'freals'
}, {
  type: 'doughnut-club',
  name: 'Pastries Club',
  matcher: 'doughnut'
}, {
  type: 'default-club',
  name: 'Pizza Slice Club',
  matcher: 'pizza slice'
}, {
  type: 'eightto10lb-ice-club',
  name: '8 to 10 lb Ice Club',
  matcher: '8 to 10 lb ice'
}, {
  type: 'twenty-lb-ice-club',
  name: '20 lb ice Club',
  matcher: '20 lb ice'
}, {
  type: 'ice-club',
  name: 'Ice Club',
  matcher: 'ice'
}, {
  type: 'default-club',
  name: '64 oz. Growler Club',
  matcher: '64 oz. growler'
}, {
  type: 'default-club',
  name: '32 oz. Growler Club',
  matcher: '32 oz. growler'
}, {
  type: 'milk-club',
  name: 'Milk Club',
  matcher: 'milk'
}, {
  type: 'energy-drink-club',
  name: 'Energy Drink Club',
  matcher: 'energy'
}, {
  type: 'breakfast-sandwich-club',
  name: 'Breakfast Sandwich Club',
  matcher: 'breakfast sandwich'
}, {
  type: 'sandwich-club',
  name: 'Sandwich Club',
  matcher: 'sandwich'
}, {
  type: 'fuel-club',
  name: 'Fuel Club',
  matcher: 'fuel'
}, {
  type: 'blue-plate-special',
  name: 'Blue Plate Special',
  matcher: 'blue plate'
}, {
  type: 'freeze-zone',
  name: 'Freeze Zone',
  matcher: 'freeze'
}, {
  type: 'liter-coke-club',
  name: 'Coke Liter Club',
  matcher: 'coke 1 liter'
}, {
  type: 'liter-water-club',
  name: 'Liter Water Club',
  matcher: '1 liter water club'
}, {
  type: 'coffee-fountain-club',
  name: 'Coffee and Fountain Drink Club',
  matcher: 'coffee and fountain drink club'
}, {
  type: 'energy-club',
  name: 'Energy Club',
  matcher: 'energy club'
}, {
  type: 'milk-gallon-club',
  name: 'Milk Gallon Club',
  matcher: 'milk gallon club'
}, {
  type: 'grill-club',
  name: 'The Grill Club',
  matcher: 'the grill club'
}, {
  type: 'liter-pepsi-club',
  name: 'Pepsi Liter Club',
  matcher: 'pepsi 1 liter'
}, {
  type: 'brat-club',
  name: 'Brat Club',
  matcher: 'brat'
}, {
  type: 'hot-dog-club',
  name: 'Hot Dog Club',
  matcher: 'hot dog club'
}, {
  type: 'core-club',
  name: 'Core Club',
  matcher: 'core'
}, {
  type: 'energy-drink-club',
  name: 'Energy Drink Club',
  matcher: 'energy drink'
},{
  type: 'coffee-tea-club',
  name: 'Coffee/Tea Club',
  matcher: 'coffee/tea'
}, {
  type: 'drink-above-club',
  name: 'Drink Club $3 and above',
  matcher: 'drink club $3 and above'
}, {
  type: 'drink-less-club',
  name: 'Drink Club .5 liter or less',
  matcher: 'drink club .5 liter or less'
}, {
  type: 'crisps-3-club',
  name: 'Crips Club 3 to 3.5 oz',
  matcher: 'crips club 3 to 3.5 oz'
}, {
  type: 'crisps-50less-club',
  name: 'Crisps Club 50gm or less',
  matcher: 'crisps club 50gm or less'
}, {
  type: 'patties-club',
  name: 'Patties Club',
  matcher: 'patties'
}, {
  type: 'chocolate-club',
  name: 'Standard Chocolate Club',
  matcher: 'chocolate'
}, {
  type: 'gatorade-28oz-club',
  name: 'Gatorade 28oz Club',
  matcher: 'gatorade 28oz'
}, {
  type: 'pepsi-20oz-club',
  name: 'Pepsi 20oz Club',
  matcher: 'pepsi 20oz'
}, {
  type: 'aquafina-20oz-club',
  name: 'Aquafina 20oz Club',
  matcher: 'aquafina 20oz'
}, {
  type: 'life-wtr-liter-club',
  name: 'Life Wtr 1 Liter Club',
  matcher: 'life wtr 1 liter'
}, {
  type: 'monster-16oz-club',
  name: 'Monster 16oz Club',
  matcher: 'monster 16oz'
}, {
  type: 'rockstar-16oz-club',
  name: 'Rockstar 16oz Club',
  matcher: 'rockstar 16oz'
}, {
  type: 'jack-links-snack-bowls-5oz-club',
  name: 'Jack Links Snack Bowls 5oz Club',
  matcher: 'jack links snack bowls 5oz'
}, {
  type: 'banana-club',
  name: 'Banana Club',
  matcher: 'banana club'
}, {
  type: 'vuse-club',
  name: 'Vuse Club',
  matcher: 'vuse'
}, {
  type: 'chix-combo-club',
  name: 'Chix Combo Club',
  matcher: 'chix combo'
}, {
  type: 'tobacco-club',
  name: 'CopeSkoal Club',
  matcher: 'altria usstc tobacco'
}, {
  type: 'hunt-brothers-whole-pizza-club',
  name: 'Hunt Brothers Whole Pizza Club',
  matcher: 'hunt brothers whole pizza club'
}, {
  type: 'hydration-club',
  name: 'Hydration Family Club',
  matcher: 'hydration'
},{
  type: 'coke-club',
  name: 'Coca Cola Family 20oz Club',
  matcher: 'coca cola'
},{
  type: 'redbull-club',
  name: 'Red Bull 8.4oz Club',
  matcher: 'red bull'
},{
  type: 'rkt-club',
  name: 'RKT Club',
  matcher: 'rkt club'
}, {
  type: 'monster-energy-club',
  name: 'Monster Energy Club',
  matcher: 'monster energy'
}, {
  type: 'celsius-energy-club',
  name: 'Celsius Energy Club',
  matcher: 'celsius energy 12oz'
}, {
  type: 'coca-cola-club',
  name: 'Coca Cola 20oz Club',
  matcher: 'coca cola 20oz club'
}, {
  type: 'dasani-1l-club',
  name: 'Dasani 1L Club',
  matcher: 'dasani 1l club'
}, {
  type: 'gatorade-water-1l-club',
  name: 'Gatorade Water 1L Club',
  matcher: 'gatorade water 1l club'
}, {
  type: 'gatorlyte-20oz-club',
  name: 'Gatorlyte 20oz Club',
  matcher: 'gatorlyte 20oz club'
}, {
  type: 'roller-grill-club',
  name: 'Roller Grill Club',
  matcher: 'roller grill club'
}, {
  type: 'smartwater-1L-club',
  name: 'Smartwater 1L Club',
  matcher: 'smartwater club 1l club'
}, {
  type: 'takis-club',
  name: 'Takis 3.25oz Club',
  matcher: 'takis club'
}, {
  type: 'rkt-club',
  name: 'RKT Clubs',
  matcher: 'rkt club'
}, {
  type: 'pepsi-20oz-club',
  name: 'Pepsi 20oz Club',
  matcher: 'pepsi 20oz club'
}, {
  type: 'muscle-milk-club',
  name: 'Muscle Milk 14oz Club',
  matcher: 'muscle milk 14oz club'
}, {
  type: 'alani-nu-12oz-club',
  name: 'AlaniNu 12oz Club',
  matcher: 'alani nu 12oz club'
}, {
  type: 'fanta-20oz-club',
  name: 'Fanta 20oz Club',
  matcher: 'fanta 20oz club'
}, {
  type: 'gatorade-propel-1l-club',
  name: 'Gatorade Propel 1L Club',
  matcher: 'propel 1l club'
}, {
  type: 'starbucks-club',
  name: 'Starbucks Doubleshot Club',
  matcher: 'starbucks doubleshot club'
}, {
  type: 'aquafina-1l-club',
  name: 'Aquafina 1L Club',
  matcher: 'aquafina 1l club'
}]

export const programs = {
  kickback: {
    supportedCards: ['wash-club', 'coffee-club', 'fountain-club', 'default-club', 'slushie-club', 'ice-club', 'doughnut-club', 'milk-club', 'energy-drink-club', 'sandwich-club', 'fuel-club']
  },
  foodnfun: {
    supportedCards: ['coffee-club', 'fountain-club']
  },
  oasis: {
    supportedCards: ['ice-club', 'coffee-club', 'fountain-club', 'hot-bev-club-refill', 'fountain-club-refill', 'freals-club']
  },
  kbrewards: {
    supportedCards: ['coffee-club', 'fountain-club']
  },
  noco: {
    supportedCards: ['coffee-club', 'fountain-club', 'default-club', 'slushie-club']
  },
  harts: {
    supportedCards: ['wash-club', 'coffee-club', 'fountain-club', 'default-club', 'slushie-club', 'ice-club', 'doughnut-club', 'milk-club', 'energy-drink-club', 'sandwich-club', 'fuel-club']
  },
  fasrewards: {
    supportedCards: ['wash-club', 'coffee-club', 'fountain-club', 'default-club', 'slushie-club', 'ice-club', 'doughnut-club', 'milk-club', 'energy-drink-club', 'breakfast-sandwich-club', 'fuel-club', 'blue-plate-special']
  },
  jacksons: {
    supportedCards: ['fountain-club', 'coffee-club', 'milk-club', 'energy-drink-club', 'banana-club' , 'vuse-club' , 'tobacco-club']
  },
  qa_regtest: {
    supportedCards: ['wash-club', 'coffee-club', 'fountain-club', 'default-club', 'slushie-club', 'ice-club', 'doughnut-club', 'fuel-club']
  },
  sprintmart: {
    supportedCards: ['ice-club', 'coffee-club', 'fountain-club', 'freeze-zone', 'chix-combo-club']
  },
  mrgas: {
    supportedCards: ['liter-coke-club', 'coffee-fountain-club', 'energy-club', 'liter-pepsi-club', 'milk-gallon-club', 'grill-club']
  },
  refuel: {
    supportedCards: ['coffee-tea-club', 'drink-above-club', 'drink-less-club', 'crisps-3-club', 'crisps-50less-club', 'patties-club', 'chocolate-club']
  },
  foodnfuel: {
    supportedCards: ['gatorade-28oz-club', 'pepsi-20oz-club', 'aquafina-20oz-club', 'life-wtr-liter-club', 'monster-16oz-club', 'rockstar-16oz-club', 'jack-links-snack-bowls-5oz-club']
  },
  extramile: {
    supportedCards: ['energy-drink-club', 'coffee-club', 'fountain-club', 'hunt-brothers-whole-pizza-club', 'liter-water-club', 'hot-dog-club']
  },
  quickstop: {
    supportedCards: ['coffee-club', 'fountain-club', 'eightto10lb-ice-club', 'twenty-lb-ice-club', 'fountain-club-refill']
  },
  millers: {
    supportedCards: ['coffee-club', 'fountain-club', 'wash-club']
  },
  fleetway: {
    supportedCards: ['coffee-club', 'fountain-club',]
  },
  rocket: {
    supportedCards: ['coffee-club', 'fountain-club', 'wash-club', 'hydration-club', 'coke-club', 'redbull-club', 'rkt-club', 'monster-energy-club', 'smartwater-1L-club', 'roller-grill-club', 'gatorlyte-20oz-club', 'gatorade-water-1l-club', 'dasani-1l-club', 'coca-cola-club', 'celsius-energy-club', 'takis-club', 'pepsi-20oz-club', 'muscle-milk-club', 'alani-nu-12oz-club', 'fanta-20oz-club', 'gatorade-propel-1l-club', 'starbucks-club', 'aquafina-1l-club']
  }
}



// WEBPACK FOOTER //
// ./src/store/programs.js